import gql from 'graphql-tag';

// TODO: ADD FAQ as default Category
export const getFAQ = gql`
query getFAQ($roleCategory: String!){
  documents(conditions : 
     {gate : and, inputs : [
       {field: categoryKey, value : $roleCategory},
    ]}
  ){
      id
      title,
      categories{
        key
      }
        
      parts{
        id
        sequence
        type
        ... on TextPart{
          text(resolveFields : true)
        }
        ... on ImagePart{
          image{
            file{
               id
               hasFile
               fileExtension
               handlerName
               webPath
               mimeType
               size
               width
               height
            }
          }
        }
        ... on VideoPart{
          video{
            file{
               id
               hasFile
               fileExtension
               handlerName
               webPath
               mimeType
               size
               width
               height
            }
          }
          poster{
            file{
               id
               hasFile
               fileExtension
               handlerName
               webPath
               mimeType
               size
               width
               height
            }
          }
        }
      }
    }
  }`;